module.exports = __webpack_public_path__ + "img/U.c8778dbd.webp";